import React, { useState, useEffect } from "react";
import {Menu, X, ChevronRight, Users, TrendingUp, Award, Sparkles, Mail, Phone, MapPin, Target, Clock, Lightbulb, Shield, CheckCircle, UserCheck, Briefcase, Heart, Eye, Zap, Rocket, Calendar, MapPinned} from 'lucide-react';
import { ContentEditor } from "./components/ContentEditor";
import { AdminPanel } from "./components/AdminPanel";
import { AdminPage } from "./components/AdminPage";
import { TaskManager } from "./components/TaskManager";
import { ReviewableElement } from "./components/ReviewableElement";
import { QualificationQuiz } from "./components/QualificationQuiz";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { HeroSlider } from "./components/HeroSlider";
import { HeroQuizSlider } from "./components/HeroQuizSlider";
import { ProblemsKeywordsSection } from "./components/ProblemsKeywordsSection";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showQuiz, setShowQuiz] = useState(false);
  const [showAdminPage, setShowAdminPage] = useState(false);
  const [showFreeCallForm, setShowFreeCallForm] = useState(false);
  const [freeCallForm, setFreeCallForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [events, setEvents] = useState<any[]>([]);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [showRegistrationForm, setShowRegistrationForm] = useState(false);
  const [registrationForm, setRegistrationForm] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [siteImages, setSiteImages] = useState<any>({});
  const [heroImages, setHeroImages] = useState<any[]>([]);
  const [heroQuizImages, setHeroQuizImages] = useState<any[]>([]);
  const [loadingImages, setLoadingImages] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const { lumi } = await import('./lib/lumi');
        const result = await lumi.entities.events.list({
          sort: { createdAt: -1 }
        });

        // Filter future events and sort by date
        const now = new Date();
        now.setHours(0, 0, 0, 0);
        const futureEvents = (result.list || []).
        filter((event) => {
          const eventDate = new Date(event.date);
          return eventDate >= now;
        }).
        sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()).
        slice(0, 3); // Limit to 3 events

        setEvents(futureEvents);
      } catch (error) {
        console.error('Erreur lors du chargement des événements:', error);
        setEvents([]);
      } finally {
        setLoadingEvents(false);
      }
    };
    fetchEvents();
  }, []);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const { lumi } = await import('./lib/lumi');
        const result = await lumi.entities.site_images.list({
          filter: { active: true },
          sort: { order: 1 }
        });

        const imagesMap: any = {};
        const heroImgList: any[] = [];
        const heroQuizImgList: any[] = [];

        (result.list || []).forEach((img: any) => {
          if (img.section === 'hero') {
            heroImgList.push(img);
          } else if (img.section === 'hero_quiz') {
            heroQuizImgList.push(img);
          } else {
            imagesMap[img.section] = img;
          }
        });

        setSiteImages(imagesMap);
        setHeroImages(heroImgList);
        setHeroQuizImages(heroQuizImgList);
      } catch (error) {
        console.error('Erreur lors du chargement des images:', error);
      } finally {
        setLoadingImages(false);
      }
    };
    fetchImages();
  }, []);

  const services = [
  {
    icon: Users,
    title: "Réseau et visibilité",
    description: "Accédez à un réseau de dirigeants et développez votre visibilité pour renforcer vos opportunités et votre activité."
  },
  {
    icon: Target,
    title: "Interface de gestion",
    description: "Des outils de pilotage adaptés à votre entreprise pour suivre vos indicateurs clés et faciliter la prise de décision."
  },
  {
    icon: Clock,
    title: "Suivi mensuel structuré",
    description: "Des rencontres régulières permettant d'analyser votre situation, de prendre du recul et d'avancer sur vos priorités."
  },
  {
    icon: Lightbulb,
    title: "Support IT",
    description: "Un appui technologique et digital pour améliorer vos outils, vos processus et votre organisation."
  },
  {
    icon: TrendingUp,
    title: "Formation",
    description: "Des formations destinées à développer vos compétences de dirigeant et à soutenir le développement de votre organisation, en interne comme dans son environnement."
  },
  {
    icon: Shield,
    title: "Gestion des conflits",
    description: "Soutien pour analyser les situations de tension au sein de votre entreprise et favoriser des solutions constructives."
  },
  {
    icon: Briefcase,
    title: "Pilotage de l'entreprise",
    description: "Un espace de réflexion et de pilotage pour prendre du recul et clarifier vos décisions stratégiques."
  },
  {
    icon: Heart,
    title: "Prévention de l'épuisement professionnel",
    description: "Un accompagnement pour identifier les signaux d'alerte et préserver l'équilibre des dirigeants et des organisations."
  },
  {
    icon: Users,
    title: "Médiation",
    description: "Une intervention neutre visant à faciliter le dialogue et à accompagner la recherche de solutions durables."
  },
  {
    icon: TrendingUp,
    title: "Négociation commerciale",
    description: "Un appui dans la préparation et la conduite de négociations, ainsi que dans les phases de réorganisation de l'entreprise, afin de construire des relations commerciales solides et durables."
  },
  {
    icon: Shield,
    title: "Gestion de l'endettement",
    description: "Soutien dans l'analyse des situations d'endettement et la recherche de solutions adaptées."
  },
  {
    icon: Rocket,
    title: "Création d'entreprise",
    description: "Un accompagnement dans les étapes de structuration et de lancement d'une nouvelle activité."
  },
  {
    icon: Briefcase,
    title: "Réorganisation d'entreprise",
    description: "Un accompagnement pour analyser l'organisation existante, clarifier les priorités et mettre en place des ajustements structurels afin de renforcer l'efficacité, la cohérence et la pérennité de l'entreprise."
  },
  {
    icon: Briefcase,
    title: "Organisation administrative",
    description: "Un appui pour structurer et optimiser les processus administratifs afin d'améliorer l'efficacité de l'organisation."
  }];


  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed w-full bg-white/95 backdrop-blur-md shadow-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <div className="flex items-center space-x-2">
                <img
                  src="https://static.lumi.new/99/99d915475a8167be6bc3a041109eb975.webp"
                  alt="Rugir Logo"
                  className="h-20 w-auto" />

              </div>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="#accueil" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
                Accueil
              </a>
              <a href="#apropos" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
                À propos
              </a>
              <a href="#methode" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
                Méthode
              </a>
              <a href="#offre" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
                Offre
              </a>
              <a href="#parcours" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
                Parcours
              </a>
              <a href="#contact" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">
                Contact
              </a>
              <ReviewableElement section="nav" contentKey="nav_cta_desktop" elementType="button">
                <button
                  onClick={() => setShowQuiz(true)}
                  className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-6 py-2 rounded-full font-medium hover:shadow-lg hover:scale-105 transition-all">Lancer le Quizz


                </button>
              </ReviewableElement>
              <AdminPanel onOpenAdminPage={() => setShowAdminPage(true)} />
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-gray-100">

              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen &&
        <div className="md:hidden bg-white border-t">
            <div className="px-4 py-4 space-y-3">
              <a href="#accueil" className="block text-gray-700 hover:text-teal-600 py-2">
                Accueil
              </a>
              <a href="#apropos" className="block text-gray-700 hover:text-teal-600 py-2">
                À propos
              </a>
              <a href="#methode" className="block text-gray-700 hover:text-teal-600 py-2">
                Méthode
              </a>
              <a href="#offre" className="block text-gray-700 hover:text-teal-600 py-2">
                Offre
              </a>
              <a href="#parcours" className="block text-gray-700 hover:text-teal-600 py-2">
                Parcours
              </a>
              <a href="#contact" className="block text-gray-700 hover:text-teal-600 py-2">
                Contact
              </a>
              <ReviewableElement section="nav" contentKey="nav_cta_mobile" elementType="button">
                <button
                onClick={() => setShowQuiz(true)}
                className="w-full bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-6 py-2 rounded-full font-medium">

                  Candidater
                </button>
              </ReviewableElement>
              <div className="pt-2 border-t border-gray-200">
                <AdminPanel onOpenAdminPage={() => setShowAdminPage(true)} />
              </div>
            </div>
          </div>
        }
      </nav>

      {/* Hero Section */}
      <section id="accueil" className="pt-32 pb-20 bg-gradient-to-br from-teal-50 via-cyan-50 to-white">
        <div className="max-w-7xl mx-auto px-4">
          {/* Logo en haut de la page d'accueil */}
          <div className="flex justify-center mb-12">
            <img
              src="https://static.lumi.new/99/99d915475a8167be6bc3a041109eb975.webp"
              alt="Rugir Logo"
              className="h-64 w-auto" />

          </div>
          <div className="text-center max-w-4xl mx-auto">
            <ReviewableElement section="hero" contentKey="hero_title" elementType="text">
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8">
                Faites <span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">RUGIR</span> votre potentiel entrepreneurial
              </h1>
            </ReviewableElement>
            
            <ReviewableElement section="hero" contentKey="hero_acronym" elementType="text">
              <div className="mb-10 text-lg md:text-xl text-gray-700 space-y-3">
                
                <p className="text-3xl"></p>
                <p className="text-3xl"><span className="font-bold text-teal-600">R</span>évéler • <span className="font-bold text-teal-600">U</span>nir • <span className="font-bold text-teal-600">G</span>randir • <span className="font-bold text-teal-600">I</span>nnover • <span className="font-bold text-teal-600">R</span>ayonner</p>
              </div>
            </ReviewableElement>

            <ReviewableElement section="hero" contentKey="hero_subtitle" elementType="text">
              <p className="text-xl md:text-2xl text-gray-600 mb-12">Ici, on ne parle pas seulement d'idées. On construit des trajectoires d'entrepreneurs.

              </p>
            </ReviewableElement>

            {/* Image(s) avant bouton Quiz - Pleine largeur */}
            {heroQuizImages.length > 0 &&
            <div className="mb-12 -mx-4 md:-mx-8 lg:-mx-16">
                <HeroQuizSlider images={heroQuizImages} />
              </div>
            }

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <ReviewableElement section="hero" contentKey="hero_cta_quiz" elementType="button">
                <button
                  onClick={() => setShowQuiz(true)}
                  className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-xl hover:scale-105 transition-all flex items-center justify-center gap-2">

                  Lancer le Quizz <ChevronRight className="w-5 h-5" />
                </button>
              </ReviewableElement>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20">
            <div className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-4xl font-bold text-teal-600 mb-2">150+</div>
              <div className="text-gray-600">Personnes et entreprises nous ont fait confiance</div>
            </div>
            <div className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-4xl font-bold text-teal-600 mb-2">50+</div>
              <div className="text-gray-600">Membres actifs</div>
            </div>
            <div className="text-center p-6 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="text-4xl font-bold text-teal-600 mb-2">95%</div>
              <div className="text-gray-600">Taux de satisfaction</div>
            </div>
          </div>
        </div>
      </section>

      {/* Problems Keywords Section */}
      <ProblemsKeywordsSection />

      {/* CTA Section - 30 min gratuit */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-600 via-cyan-600 to-teal-600">
        <div className="max-w-4xl mx-auto text-center">
          <ReviewableElement section="cta_free" contentKey="cta_free_title" elementType="text">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Offre Découverte : 30 minutes gratuites
            </h2>
          </ReviewableElement>
          <ReviewableElement section="cta_free" contentKey="cta_free_description" elementType="text">
            <p className="text-xl text-white/90 mb-8">Cet échange vous permettra de prendre du recul sur votre situation personnelle et professionnelle, d'identifier clairement vos défis actuels, de mettre en lumière vos opportunités et de découvrir comment <span className="font-bold">RUGIR</span> peut vous accompagner dans votre développement entrepreneurial.

            </p>
          </ReviewableElement>
          <ReviewableElement section="cta_free" contentKey="cta_free_button" elementType="button">
            <button
              onClick={() => setShowFreeCallForm(true)}
              className="bg-white text-teal-600 px-10 py-4 rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all inline-flex items-center gap-2">

              Réserver mon appel gratuit <Phone className="w-5 h-5" />
            </button>
          </ReviewableElement>
        </div>
      </section>

      {/* Events Section - Only show if there are events */}
      {!loadingEvents && events.length > 0 &&
      <section id="evenements" className="py-20 px-4 bg-gray-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <ReviewableElement section="events" contentKey="events_title" elementType="text">
                <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                  Prochains Événements & Conférences
                </h2>
              </ReviewableElement>
              <ReviewableElement section="events" contentKey="events_subtitle" elementType="text">
                <p className="text-xl text-gray-600">Participez à nos rencontres exclusives pour enrichir votre réseau, partager des expériences entre dirigeants et développer de nouvelles perspectives pour votre activité.

                </p>
              </ReviewableElement>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {events.map((event, index) =>
            <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all p-8 border-t-4 border-teal-600">
                  <div className="flex items-center gap-2 text-teal-600 mb-2">
                    <Calendar className="w-5 h-5" />
                    <span className="font-semibold">{new Date(event.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                  </div>
                  <div className="text-gray-600 mb-4 text-sm font-medium">
                    {event.startTime} - {event.endTime}
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{event.title}</h3>
                  <div className="flex items-center gap-2 text-gray-600 mb-4">
                    <MapPinned className="w-5 h-5" />
                    <span>{event.location}</span>
                  </div>
                  <p className="text-gray-600 mb-6">{event.description}</p>
                  <button
                onClick={() => {
                  setSelectedEvent(event);
                  setShowRegistrationForm(true);
                }}
                className="w-full bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-6 py-3 rounded-full font-semibold hover:shadow-lg hover:scale-105 transition-all">
                    S'inscrire
                  </button>
                </div>
            )}
            </div>
          </div>
        </section>
      }

      {/* About Section */}
      <section id="apropos" className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            {/* Logo au-dessus de la section À propos */}
            <div className="flex justify-center mb-8">
              <img
                src="https://static.lumi.new/99/99d915475a8167be6bc3a041109eb975.webp"
                alt="Rugir Logo"
                className="h-32 w-auto" />
            </div>
            <ReviewableElement section="about" contentKey="about_title" elementType="text">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                À propos de <span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">RUGIR</span>
              </h2>
            </ReviewableElement>
            <ReviewableElement section="about" contentKey="about_mission" elementType="text">
              <div className="text-xl text-gray-600 max-w-3xl mx-auto space-y-4">
                <p><span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent font-bold">RUGIR</span> est une association qui réunit des chefs d'entreprise, dirigeants et adultes en responsabilité souhaitant bénéficier d'un espace de réflexion, de prise de recul et d'accompagnement pour mieux piloter leur activité et leurs décisions.</p>
                <p>L'association propose des actions de formation, d'accompagnement et des temps d'échange entre pairs afin de prévenir les difficultés, rompre l'isolement décisionnel et soutenir des trajectoires professionnelles et entrepreneuriales durables.</p>
                <p>Un ensemble de compétences et d'expériences mobilisées au service du développement des dirigeants et de la pérennité de leurs organisations.</p>
              </div>
            </ReviewableElement>
            <ReviewableElement section="about" contentKey="about_mission_tagline" elementType="text">
              <p className="text-lg text-teal-600 font-semibold mt-4">Un éventail de compétences au service de votre croissance.

              </p>
            </ReviewableElement>
            <div className="mt-8">
              <button
                onClick={() => setShowQuiz(true)}
                className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-8 py-3 rounded-full text-lg font-semibold hover:shadow-xl hover:scale-105 transition-all inline-flex items-center gap-2">
                Découvrir comment RUGIR peut vous aider <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ... keep existing code */}

      {/* Notre Démarche Section */}
      <section id="demarche" className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <ReviewableElement section="demarche" contentKey="demarche_title" elementType="text">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Notre Démarche
              </h2>
            </ReviewableElement>
            <ReviewableElement section="demarche" contentKey="demarche_subtitle" elementType="text">
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">Une approche structurée pour révéler votre plein potentiel entrepreneurial.

              </p>
            </ReviewableElement>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
              <img
                src={siteImages.demarche_1?.imageUrl || "https://images.pexels.com/photos/3184639/pexels-photo-3184639.jpeg?auto=compress&cs=tinysrgb&w=800"}
                alt={siteImages.demarche_1?.altText || "Conviction"}
                className="w-full h-48 object-cover" />

              <div className="p-8">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                  <Eye className="w-8 h-8 text-white" />
                </div>
                <ReviewableElement section="demarche" contentKey="demarche_conviction" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Notre Conviction</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    La solidité d'une organisation repose sur des décisions claires et sur l'alignement entre le dirigeant, son projet et son entreprise. Cet équilibre constitue un levier essentiel pour construire des trajectoires durables.
                  </p>
                </ReviewableElement>
                <button
                  onClick={() => setShowQuiz(true)}
                  className="text-teal-600 hover:text-teal-700 font-semibold inline-flex items-center gap-1 transition-colors">
                  En savoir plus <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
              <img
                src={siteImages.demarche_2?.imageUrl || "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=800"}
                alt={siteImages.demarche_2?.altText || "Diagnostic"}
                className="w-full h-48 object-cover" />

              <div className="p-8">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                  <Target className="w-8 h-8 text-white" />
                </div>
                <ReviewableElement section="demarche" contentKey="demarche_diagnostic" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Diagnostic de Situation</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Des outils d'analyse permettent aux dirigeants de prendre du recul, d'identifier leurs priorités et de mieux comprendre les enjeux auxquels ils sont confrontés.
                  </p>
                </ReviewableElement>
                <button
                  onClick={() => setShowQuiz(true)}
                  className="text-teal-600 hover:text-teal-700 font-semibold inline-flex items-center gap-1 transition-colors">
                  En savoir plus <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
              <img
                src={siteImages.demarche_3?.imageUrl || "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=800"}
                alt={siteImages.demarche_3?.altText || "Formation"}
                className="w-full h-48 object-cover" />

              <div className="p-8">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <ReviewableElement section="demarche" contentKey="demarche_formation" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Formation</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Des sessions destinées aux dirigeants et aux employés pour analyser des situations concrètes, partager les expériences et acquérir des repères et des outils utiles au pilotage et au bon fonctionnement de l'entreprise.
                  </p>
                </ReviewableElement>
                <button
                  onClick={() => setShowQuiz(true)}
                  className="text-teal-600 hover:text-teal-700 font-semibold inline-flex items-center gap-1 transition-colors">
                  En savoir plus <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
              <img
                src={siteImages.demarche_4?.imageUrl || "https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=800"}
                alt={siteImages.demarche_4?.altText || "Accompagnement"}
                className="w-full h-48 object-cover" />

              <div className="p-8">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                  <Zap className="w-8 h-8 text-white" />
                </div>
                <ReviewableElement section="demarche" contentKey="demarche_accompagnement" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Accompagnement</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Un appui individuel et collectif pour soutenir la prise de décision, renforcer le pilotage de l'organisation et accompagner les périodes de transformation ou de transition.
                  </p>
                </ReviewableElement>
                <button
                  onClick={() => setShowQuiz(true)}
                  className="text-teal-600 hover:text-teal-700 font-semibold inline-flex items-center gap-1 transition-colors">
                  En savoir plus <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl shadow-xl p-8 text-white">
            <div className="max-w-4xl mx-auto text-center">
              <ReviewableElement section="demarche" contentKey="demarche_piliers" elementType="text">
                <h3 className="text-2xl font-bold mb-4">Les Cinq Piliers de la Croissance Globale</h3>
                <p className="text-lg leading-relaxed">
                  Notre méthode <span className="font-bold">RUGIR</span> repose sur cinq piliers fondamentaux : <strong>Révéler</strong> votre potentiel, <strong>Unir</strong> vos forces, <strong>Grandir</strong> ensemble, <strong>Innover</strong> pour vous démarquer, et <strong>Rayonner</strong> dans votre écosystème.
                </p>
              </ReviewableElement>
            </div>
          </div>
        </div>
      </section>

      {/* Méthode RUGIR Section */}
      <section id="methode" className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <ReviewableElement section="methode" contentKey="methode_title" elementType="text">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                La Méthode <span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">RUGIR</span>
              </h2>
            </ReviewableElement>
            <ReviewableElement section="methode" contentKey="methode_subtitle" elementType="text">
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">Cinq piliers pour révéler votre plein potentiel entrepreneurial.

              </p>
            </ReviewableElement>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
              <img
                src={siteImages.pillar_r?.imageUrl || "https://images.pexels.com/photos/3184306/pexels-photo-3184306.jpeg?auto=compress&cs=tinysrgb&w=800"}
                alt={siteImages.pillar_r?.altText || "Révéler"}
                className="w-full h-48 object-cover" />

              <div className="p-8">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                  <Eye className="w-8 h-8 text-white" />
                </div>
                <ReviewableElement section="methode" contentKey="methode_reveler" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Révéler</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Identifiez vos forces et clarifiez votre vision pour orienter votre entreprise avec cohérence.
                  </p>
                </ReviewableElement>
                <button
                  onClick={() => setShowQuiz(true)}
                  className="text-teal-600 hover:text-teal-700 font-semibold inline-flex items-center gap-1 transition-colors">
                  En savoir plus <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
              <img
                src={siteImages.pillar_u?.imageUrl || "https://images.pexels.com/photos/3184325/pexels-photo-3184325.jpeg?auto=compress&cs=tinysrgb&w=800"}
                alt={siteImages.pillar_u?.altText || "Unir"}
                className="w-full h-48 object-cover" />

              <div className="p-8">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                  <Users className="w-8 h-8 text-white" />
                </div>
                <ReviewableElement section="methode" contentKey="methode_unir" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Unir</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Rassemblez vos équipes et votre réseau autour d'objectifs communs.
                  </p>
                </ReviewableElement>
                <button
                  onClick={() => setShowQuiz(true)}
                  className="text-teal-600 hover:text-teal-700 font-semibold inline-flex items-center gap-1 transition-colors">
                  En savoir plus <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
              <img
                src={siteImages.pillar_g?.imageUrl || "https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg?auto=compress&cs=tinysrgb&w=800"}
                alt={siteImages.pillar_g?.altText || "Grandir"}
                className="w-full h-48 object-cover" />

              <div className="p-8">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                  <TrendingUp className="w-8 h-8 text-white" />
                </div>
                <ReviewableElement section="methode" contentKey="methode_grandir" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Grandir</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Développez des offres adaptées aux besoins du marché et faites évoluer votre activité.
                  </p>
                </ReviewableElement>
                <button
                  onClick={() => setShowQuiz(true)}
                  className="text-teal-600 hover:text-teal-700 font-semibold inline-flex items-center gap-1 transition-colors">
                  En savoir plus <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all">
              <img
                src={siteImages.pillar_i?.imageUrl || "https://images.pexels.com/photos/3184357/pexels-photo-3184357.jpeg?auto=compress&cs=tinysrgb&w=800"}
                alt={siteImages.pillar_i?.altText || "Innover"}
                className="w-full h-48 object-cover" />

              <div className="p-8">
                <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                  <Lightbulb className="w-8 h-8 text-white" />
                </div>
                <ReviewableElement section="methode" contentKey="methode_innover" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">Innover</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    Faites évoluer vos pratiques et structurez votre organisation avec des méthodes et des outils concrets.
                  </p>
                </ReviewableElement>
                <button
                  onClick={() => setShowQuiz(true)}
                  className="text-teal-600 hover:text-teal-700 font-semibold inline-flex items-center gap-1 transition-colors">
                  En savoir plus <ChevronRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden">
            {/* Slider Rayonner */}
            {heroImages.length > 0 ?
            <HeroSlider images={heroImages.map((img) => ({ imageUrl: img.imageUrl, altText: img.altText, caption: img.caption || '' }))} /> :

            <img
              src={siteImages.pillar_r2?.imageUrl || "https://images.pexels.com/photos/3184297/pexels-photo-3184297.jpeg?auto=compress&cs=tinysrgb&w=1600"}
              alt={siteImages.pillar_r2?.altText || "Rayonner"}
              className="w-full h-80 object-cover rounded-2xl" />

            }
            <div className="bg-gradient-to-r from-teal-600 to-cyan-600 p-8 text-white">
              <div className="max-w-4xl mx-auto text-center">
                <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mb-6 mx-auto">
                  <Sparkles className="w-8 h-8 text-white" />
                </div>
                <ReviewableElement section="methode" contentKey="methode_rayonner" elementType="text">
                  <h3 className="text-2xl font-bold mb-4">Rayonner</h3>
                  <p className="text-lg leading-relaxed">Affirmez votre posture de dirigeant, engagez-vous pleinement dans votre rôle et développez votre visibilité pour renforcer votre impact dans votre écosystème.

                  </p>
                </ReviewableElement>
                <div className="mt-6 text-center">
                  <button
                    onClick={() => setShowQuiz(true)}
                    className="bg-white text-teal-600 px-8 py-3 rounded-full font-semibold hover:shadow-xl hover:scale-105 transition-all inline-flex items-center gap-2">
                    Rejoindre RUGIR <ChevronRight className="w-5 h-5" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="offre" className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <ReviewableElement section="services" contentKey="services_title" elementType="text">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Notre Offre
              </h2>
            </ReviewableElement>
            <ReviewableElement section="services" contentKey="services_subtitle" elementType="text">
              <p className="text-xl text-gray-600">Un accompagnement structuré pour soutenir le développement de votre entreprise.

              </p>
            </ReviewableElement>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all p-8 border-t-4 border-teal-600">
                  <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-xl flex items-center justify-center mb-6">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed mb-4">{service.description}</p>
                  <button
                    onClick={() => setShowQuiz(true)}
                    className="text-teal-600 hover:text-teal-700 font-semibold inline-flex items-center gap-1 transition-colors">
                    En savoir plus <ChevronRight className="w-4 h-4" />
                  </button>
                </div>);

            })}
          </div>

          <div className="mt-16 bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl shadow-xl p-8 md:p-12 text-white">
            <div className="max-w-4xl mx-auto">
              <ReviewableElement section="services" contentKey="services_differentiators_title" elementType="text">
                <h3 className="text-3xl font-bold mb-6 text-center">Ce qui nous différencie</h3>
              </ReviewableElement>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="flex items-start gap-4">
                  <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                  <ReviewableElement section="services" contentKey="services_diff_1" elementType="text">
                    <p className="text-lg">
                      <strong>Formation</strong> : Des sessions collaboratives centrées sur l'analyse de situations réelles, enrichies par les échanges entre dirigeants et l'intelligence collective.
                    </p>
                  </ReviewableElement>
                </div>
                <div className="flex items-start gap-4">
                  <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                  <ReviewableElement section="services" contentKey="services_diff_2" elementType="text">
                    <p className="text-lg">
                      <strong>Événements</strong> : Des rencontres et ateliers dédiés aux membres pour favoriser les échanges, le partage d'expériences et le développement du réseau.
                    </p>
                  </ReviewableElement>
                </div>
                <div className="flex items-start gap-4">
                  <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                  <ReviewableElement section="services" contentKey="services_diff_3" elementType="text">
                    <p className="text-lg">
                      <strong>Intelligence collective et expertises</strong> : L'apport des expériences du groupe complété par des compétences spécialisées et un accompagnement structuré.
                    </p>
                  </ReviewableElement>
                </div>
                <div className="flex items-start gap-4">
                  <CheckCircle className="w-6 h-6 flex-shrink-0 mt-1" />
                  <ReviewableElement section="services" contentKey="services_diff_4" elementType="text">
                    <p className="text-lg">
                      <strong>Accompagnement</strong> : Un suivi adapté aux besoins des dirigeants, combinant temps d'échange, outils de pilotage et appui dans la prise de décision.
                    </p>
                  </ReviewableElement>
                </div>
              </div>
              <div className="text-center">
                <button
                  onClick={() => setShowFreeCallForm(true)}
                  className="bg-white text-teal-600 px-10 py-4 rounded-full text-lg font-bold hover:shadow-2xl hover:scale-105 transition-all inline-flex items-center gap-2">
                  Réserver mon appel découverte <Phone className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <TestimonialsSection />

      {/* Parcours Section */}
      <section id="parcours" className="py-20 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <ReviewableElement section="parcours" contentKey="parcours_title" elementType="text">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                Votre Parcours avec <span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">RUGIR</span>
              </h2>
            </ReviewableElement>
            <ReviewableElement section="parcours" contentKey="parcours_subtitle" elementType="text">
              <p className="text-xl text-gray-600">
                Un processus structuré pour analyser votre situation et accompagner votre progression.
              </p>
            </ReviewableElement>
          </div>

          <div className="space-y-8">
            <div className="flex items-start gap-6 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 hover:shadow-lg transition-all">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-xl">
                1
              </div>
              <div>
                <ReviewableElement section="parcours" contentKey="parcours_step1_title" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Diagnostic Initial</h3>
                </ReviewableElement>
                <ReviewableElement section="parcours" contentKey="parcours_step1_desc" elementType="text">
                  <p className="text-gray-600 leading-relaxed">
                    Une première étape d'évaluation, à travers un quiz, permettant d'identifier votre situation, vos besoins et les enjeux prioritaires de votre activité.
                  </p>
                </ReviewableElement>
              </div>
            </div>

            <div className="flex items-start gap-6 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 hover:shadow-lg transition-all">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-xl">
                2
              </div>
              <div>
                <ReviewableElement section="parcours" contentKey="parcours_step2_title" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Premier échange</h3>
                </ReviewableElement>
                <ReviewableElement section="parcours" contentKey="parcours_step2_desc" elementType="text">
                  <p className="text-gray-600 leading-relaxed">
                    Un entretien destiné à mieux comprendre votre contexte, vos défis et à déterminer les modalités d'accompagnement possibles.
                  </p>
                </ReviewableElement>
              </div>
            </div>

            <div className="flex items-start gap-6 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 hover:shadow-lg transition-all">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-xl">
                3
              </div>
              <div>
                <ReviewableElement section="parcours" contentKey="parcours_step3_title" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Rencontre en présentiel</h3>
                </ReviewableElement>
                <ReviewableElement section="parcours" contentKey="parcours_step3_desc" elementType="text">
                  <p className="text-gray-600 leading-relaxed">
                    Une rencontre organisée dans vos locaux afin d'échanger sur la situation de l'entreprise et de présenter plus en détail les compétences et les services proposés.
                  </p>
                </ReviewableElement>
              </div>
            </div>

            <div className="flex items-start gap-6 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 hover:shadow-lg transition-all">
              <div className="w-12 h-12 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center flex-shrink-0 text-white font-bold text-xl">
                4
              </div>
              <div>
                <ReviewableElement section="parcours" contentKey="parcours_step4_title" elementType="text">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Accompagnement</h3>
                </ReviewableElement>
                <ReviewableElement section="parcours" contentKey="parcours_step4_desc" elementType="text">
                  <p className="text-gray-600 leading-relaxed">
                    La mise en place d'un accompagnement adapté comprenant des temps d'échange, des outils de pilotage et l'accès à un réseau de dirigeants et de compétences.
                  </p>
                </ReviewableElement>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <ReviewableElement section="parcours" contentKey="parcours_cta" elementType="button">
              <button
                onClick={() => setShowQuiz(true)}
                className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:shadow-xl hover:scale-105 transition-all inline-flex items-center gap-2">

                Lancer le Quizz <ChevronRight className="w-5 h-5" />
              </button>
            </ReviewableElement>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <ReviewableElement section="contact" contentKey="contact_title" elementType="text">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              Prêt à <span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">RUGIR</span> ?
            </h2>
          </ReviewableElement>
          <ReviewableElement section="contact" contentKey="contact_subtitle" elementType="text">
            <p className="text-xl text-gray-600 mt-8 mb-12">
              Rejoignez un réseau de dirigeants et bénéficiez d'un accompagnement structuré pour soutenir le développement de votre activité.
            </p>
          </ReviewableElement>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12 max-w-2xl mx-auto">
            <div className="flex flex-col items-center">
              <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center mb-4">
                <Mail className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Email</h3>
              <a href="mailto:contact@rugir.ch" className="text-teal-600 hover:text-teal-700">info@rugir.ch

              </a>
            </div>

            <div className="flex flex-col items-center">
              <div className="w-14 h-14 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center mb-4">
                <MapPin className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Adresse</h3>
              <p className="text-gray-600">Suisse romande</p>
            </div>
          </div>

          <ReviewableElement section="contact" contentKey="contact_cta" elementType="button">
            <button
              onClick={() => setShowQuiz(true)}
              className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:shadow-xl hover:scale-105 transition-all inline-flex items-center gap-2">

              Lancer le Quizz <ChevronRight className="w-5 h-5" />
            </button>
          </ReviewableElement>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <img
                  src="https://static.lumi.new/99/99d915475a8167be6bc3a041109eb975.webp"
                  alt="Rugir Logo"
                  className="h-20 w-auto" />

              </div>
              <p className="text-gray-400">
                Révélez votre potentiel entrepreneurial
              </p>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Navigation</h4>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#accueil" className="hover:text-white transition-colors">Accueil</a></li>
                <li><a href="#apropos" className="hover:text-white transition-colors">À propos</a></li>
                <li><a href="#methode" className="hover:text-white transition-colors">Méthode</a></li>
                <li><a href="#offre" className="hover:text-white transition-colors">Offre</a></li>
                <li><a href="#contact" className="hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-gray-400">
                <li>Email: contact@rugir.ch</li>
                <li>Genève, Suisse</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 text-center text-gray-400">
            <p>&copy; 2025 <span className="bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent font-semibold">RUGIR</span>. Tous droits réservés.</p>
          </div>
        </div>
      </footer>

      <ContentEditor />
      <TaskManager />
      
      {showQuiz && <QualificationQuiz onClose={() => setShowQuiz(false)} />}
      {showAdminPage && <AdminPage onClose={() => setShowAdminPage(false)} />}
      
      {/* Free Call Form Modal */}
      {showFreeCallForm &&
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-8">
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-2">Réserver mon appel gratuit</h2>
                <p className="text-lg text-gray-600">Remplissez ce formulaire et nous vous contacterons sous 48h pour planifier votre session gratuite de 30 minutes.</p>
              </div>
              <button
              onClick={() => {
                setShowFreeCallForm(false);
                setFreeCallForm({ firstName: '', lastName: '', email: '', phone: '', company: '', message: '' });
              }}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors">

                <X className="w-6 h-6 text-gray-600" />
              </button>
            </div>

            <form
            onSubmit={async (e) => {
              e.preventDefault();
              try {
                const { lumi } = await import('./lib/lumi');
                await lumi.entities.contact_requests.create({
                  firstName: freeCallForm.firstName,
                  lastName: freeCallForm.lastName,
                  email: freeCallForm.email,
                  phone: freeCallForm.phone,
                  company: freeCallForm.company,
                  message: freeCallForm.message || 'Demande d\'appel gratuit de 30 minutes',
                  quizResponseId: null,
                  status: 'pending',
                  requestType: 'free_call',
                  createdAt: new Date().toISOString(),
                  updatedAt: new Date().toISOString()
                });
                alert('✅ Votre demande a été envoyée avec succès ! Un membre de notre équipe vous contactera sous 48h pour planifier votre appel gratuit de 30 minutes.');
                setShowFreeCallForm(false);
                setFreeCallForm({ firstName: '', lastName: '', email: '', phone: '', company: '', message: '' });
              } catch (error) {
                console.error('Erreur lors de l\'envoi de la demande:', error);
                alert('❌ Erreur lors de l\'envoi. Veuillez réessayer.');
              }
            }}
            className="space-y-6">

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Prénom *
                  </label>
                  <input
                  type="text"
                  value={freeCallForm.firstName}
                  onChange={(e) => setFreeCallForm({ ...freeCallForm, firstName: e.target.value })}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none"
                  required
                  placeholder="Jean" />

                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Nom *
                  </label>
                  <input
                  type="text"
                  value={freeCallForm.lastName}
                  onChange={(e) => setFreeCallForm({ ...freeCallForm, lastName: e.target.value })}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none"
                  required
                  placeholder="Dupont" />

                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  <Mail className="w-4 h-4 inline mr-1" />
                  Email *
                </label>
                <input
                type="email"
                value={freeCallForm.email}
                onChange={(e) => setFreeCallForm({ ...freeCallForm, email: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none"
                required
                placeholder="jean.dupont@exemple.com" />

              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  <Phone className="w-4 h-4 inline mr-1" />
                  Téléphone *
                </label>
                <input
                type="tel"
                value={freeCallForm.phone}
                onChange={(e) => setFreeCallForm({ ...freeCallForm, phone: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none"
                required
                placeholder="+41 12 345 67 89" />

              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Entreprise *
                </label>
                <input
                type="text"
                value={freeCallForm.company}
                onChange={(e) => setFreeCallForm({ ...freeCallForm, company: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none"
                required
                placeholder="Nom de votre entreprise" />

              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Message (optionnel)
                </label>
                <textarea
                value={freeCallForm.message}
                onChange={(e) => setFreeCallForm({ ...freeCallForm, message: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none resize-none"
                rows={4}
                placeholder="Parlez-nous brièvement de vos attentes pour cet appel gratuit..." />

              </div>

              <div className="flex gap-4">
                <button
                type="submit"
                className="flex-1 bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition-all">

                  Envoyer ma demande
                </button>
                <button
                type="button"
                onClick={() => {
                  setShowFreeCallForm(false);
                  setFreeCallForm({ firstName: '', lastName: '', email: '', phone: '', company: '', message: '' });
                }}
                className="px-6 py-3 bg-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-400 transition-all">

                  Annuler
                </button>
              </div>

              <div className="p-4 bg-teal-50 border border-teal-200 rounded-xl">
                <p className="text-sm text-teal-800 text-center">
                  🔒 Vos informations sont confidentielles et ne seront utilisées que pour vous contacter dans le cadre de votre demande d'appel gratuit.
                </p>
              </div>
            </form>
          </div>
        </div>
      }
      
      {/* Event Registration Form Modal */}
      {showRegistrationForm && selectedEvent &&
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto p-8">
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-2">S'inscrire à l'événement</h2>
                <p className="text-lg text-teal-600 font-semibold">{selectedEvent.title}</p>
                <p className="text-gray-600">{new Date(selectedEvent.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })} • {selectedEvent.startTime} - {selectedEvent.endTime}</p>
              </div>
              <button
              onClick={() => {
                setShowRegistrationForm(false);
                setSelectedEvent(null);
                setRegistrationForm({ name: '', email: '', phone: '', company: '', message: '' });
              }}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors">

                <X className="w-6 h-6 text-gray-600" />
              </button>
            </div>

            <form
            onSubmit={async (e) => {
              e.preventDefault();
              try {
                const { lumi } = await import('./lib/lumi');
                await lumi.entities.event_registrations.create({
                  eventId: selectedEvent._id,
                  eventTitle: selectedEvent.title,
                  name: registrationForm.name,
                  email: registrationForm.email,
                  phone: registrationForm.phone,
                  company: registrationForm.company,
                  message: registrationForm.message,
                  status: 'pending',
                  creator: 'anonymous',
                  createdAt: new Date().toISOString(),
                  updatedAt: new Date().toISOString()
                });
                alert('Inscription réussie ! Nous vous contacterons bientôt.');
                setShowRegistrationForm(false);
                setSelectedEvent(null);
                setRegistrationForm({ name: '', email: '', phone: '', company: '', message: '' });
              } catch (error) {
                console.error('Erreur lors de l\'inscription:', error);
                alert('Erreur lors de l\'inscription. Veuillez réessayer.');
              }
            }}
            className="space-y-6">

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Nom complet *
                </label>
                <input
                type="text"
                value={registrationForm.name}
                onChange={(e) => setRegistrationForm({ ...registrationForm, name: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none"
                required
                placeholder="Jean Dupont" />

              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email *
                </label>
                <input
                type="email"
                value={registrationForm.email}
                onChange={(e) => setRegistrationForm({ ...registrationForm, email: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none"
                required
                placeholder="jean.dupont@example.com" />

              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Téléphone *
                </label>
                <input
                type="tel"
                value={registrationForm.phone}
                onChange={(e) => setRegistrationForm({ ...registrationForm, phone: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none"
                required
                placeholder="+41 12 345 67 89" />

              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Entreprise *
                </label>
                <input
                type="text"
                value={registrationForm.company}
                onChange={(e) => setRegistrationForm({ ...registrationForm, company: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none"
                required
                placeholder="Nom de votre entreprise" />

              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Message (optionnel)
                </label>
                <textarea
                value={registrationForm.message}
                onChange={(e) => setRegistrationForm({ ...registrationForm, message: e.target.value })}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-teal-600 focus:outline-none resize-none"
                rows={4}
                placeholder="Parlez-nous de vos attentes pour cet événement..." />

              </div>

              <div className="flex gap-4">
                <button
                type="submit"
                className="flex-1 bg-gradient-to-r from-teal-600 to-cyan-600 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition-all">

                  Confirmer l'inscription
                </button>
                <button
                type="button"
                onClick={() => {
                  setShowRegistrationForm(false);
                  setSelectedEvent(null);
                  setRegistrationForm({ name: '', email: '', phone: '', company: '', message: '' });
                }}
                className="px-6 py-3 bg-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-400 transition-all">

                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    </div>);

}

export default App;